import * as React from "react"
import cx from "classnames"

import { FlowSectionState, FlowQuestionId } from "types"
import * as styles from "./styles.module.scss"

export interface SectionProps {
  children?: React.ReactNode
  className?: string
  currentId: FlowQuestionId
  dataJsPosition?: string
  dataQa?: string
  flowKey: FlowQuestionId
  previousId?: FlowQuestionId
}

const Section: React.FC<SectionProps> = ({
  flowKey,
  currentId,
  children,
  className,
  dataQa,
  dataJsPosition,
  previousId,
}) => {
  const getState = () => {
    if (currentId === flowKey) {
      return FlowSectionState.Active
    } else if (previousId === flowKey) {
      return FlowSectionState.Prev
    } else {
      return FlowSectionState.Next
    }
  }

  const state = getState()

  return (
    <section
      id={flowKey}
      data-qa={dataQa}
      data-js-position={dataJsPosition}
      className={cx({
        [styles.section]: true,
        [className]: !!className,
      })}
      data-flow={state}
    >
      {children}
    </section>
  )
}

export default Section
